import request from '../utils/request';

const mole = 'users';
export default {
  login: params => {
    return request({
      url: `/api/${mole}/login`,
      method: 'post',
      data: params
    });
  },

  logout: () => {
    return request({
      url: `/api/${mole}/logout`,
      method: 'get'
    });
  },

  findById: id => {
    return request({
      url: `/api/${mole}/get/${id}`,
      method: 'get'
    });
  }
};
